export const wsConnect = host => ({ type: 'WS_CONNECT', host });
const wsConnected = host => ({ type: 'WS_CONNECTED', host });
const wsDisconnected = host => ({ type: 'WS_DISCONNECTED', host });
export const sendSocketMessage = msg => ({ type: 'NEW_MESSAGE', msg });
const incomingMessage = msg => ({ type: msg.socketType ? msg.socketType : msg.type, msg });

const socketMiddleware = () => {
    let socket = null;
    let heartbeatInterval = null;

    const onOpen = store => (event) => {
        store.dispatch(wsConnected(event.target.url));
        if (heartbeatInterval) {
            clearInterval(heartbeatInterval);
        }
        heartbeatInterval = setInterval(() => sendMsg(JSON.stringify({ "action": "heartbeat", "data": "1" })), 60000)
    };

    const onClose = store => () => {
        store.dispatch(wsDisconnected());
        if (heartbeatInterval) {
            clearInterval(heartbeatInterval);
        }
    };

    const onMessage = store => (event) => {
        let data = JSON.parse(event.data);
        if (data.message == "Internal server error") {
            console.log("Internal server error in socket connection")
        }
        else {
            store.dispatch(incomingMessage(data));
        }

    };

    const sendMsg = (msg) => {
        //CONNECTED
        if (socket.readyState === 1) {
            socket.send(msg);
        }
        //CONNECTING
        else if (socket.readyState === 0) {
            console.log("Socket is connecting, re-try to send again");
            setTimeout(sendMsg.bind(this, msg), 300);
        }
        //CLOSING-CLOSED
        else {
            console.log("Socket is closing/closed!");
        }

    }

    return store => next => (action) => {
        switch (action.type) {
            case 'WS_CONNECT':
                if (socket !== null) {
                    socket.close();
                }

                socket = new WebSocket(action.host);

                socket.onmessage = onMessage(store);
                socket.onclose = onClose(store);
                socket.onopen = onOpen(store);

                break;
            case 'WS_DISCONNECT':
                if (socket !== null) {
                    socket.close();
                }
                socket = null;
                break;
            case 'NEW_MESSAGE':
                sendMsg(JSON.stringify(action.msg));
                break;
            default:
                return next(action);
        }
    };
};

export default socketMiddleware();
